import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataTables from "../../../components/Datatable";
import actionTypes from "../../../redux/withdraw/actionTypes";
import { withdrawApi } from "../../../api";
import { Edit } from "./edit";

const ConfigWithDraw = () => {
  const dispatch = useDispatch();
  const withdrawals = useSelector((state) => state.withdraw.withdrawals);

  console.log(withdrawals);
  // Función para obtener los retiros desde la API
  useEffect(() => {
    const getWithdrawalsAsync = async () => {
      const response = await withdrawApi.withdrawals();
      dispatch(actionTypes.getWithdrawals(response.data.data));
    };
    getWithdrawalsAsync();
  }, [dispatch]);

  // Definir las columnas del DataTable
  const columns = (row) => ({
    name: row.name || "-", // Manejo de valores vacíos
    rate: row.rate || "0.0000", // Manejo de valores vacíos
    opciones: <Edit withdraw={row} />, // Botón de edición para cada fila
  });

  return (
    <DataTables
      columns={columns}
      dispatchable={(query) => dispatch(actionTypes.getWithdrawals(query))}
      selectable={(state) => ({ data: state.withdraw.withdrawals })} // Ajuste para que `data` esté correctamente estructurado
      title="Configuración de Retiros"
      fire={false} // No disparamos la búsqueda automática, lo hacemos con useEffect
    />
  );
};

export default ConfigWithDraw;
